import {Component} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DxDropDownButtonModule, DxSelectBoxModule, DxSwitchModule, DxTextBoxModule} from 'devextreme-angular';
import {ThemeObject, ThemeService} from '../theme.service';

@Component({
  selector: 'dk-theme-switcher',
  templateUrl: './theme-switcher.component.html',
  styleUrls: ['./theme-switcher.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    DxSelectBoxModule,
    DxSelectBoxModule,
    DxTextBoxModule,
    DxSwitchModule,
    DxDropDownButtonModule
  ],
})
export class ThemeSwitcherComponent {
  themeSettings: ThemeObject[];
  themeName: string;
  public themeMode: 'M' | 'G' = 'G';

  constructor(public themeService: ThemeService) {
    this.themeSettings = themeService.getThemeSettings();
    this.themeService.setAppTheme();
    this.themeName = themeService.getCurrentThemeName()
  }

  /** Tema renk örneği: menü zemini + gerçek vurgu (ThemeBuilder ekli temalarda widget rengi). */
  private static readonly ORNEKLER: { [ad: string]: { zemin: string; vurgu: string } } = {
    'Normal': { zemin: '#deedf7', vurgu: '#337ab7' },
    'Gece': { zemin: '#353535', vurgu: '#3debd3' },
    'Kontrast': { zemin: '#010101', vurgu: '#cf00d7' },
    'Carmine': { zemin: '#ffe0b2', vurgu: '#f06f59' },
    'Softdark': { zemin: '#3a3633', vurgu: '#1e8de8' },
    'Darkmoon': { zemin: '#596980', vurgu: '#3debd3' },
    'Darkviolet': { zemin: '#010101', vurgu: '#9c63ff' },
    'Greenmist': { zemin: '#c8e6c9', vurgu: '#337ab7' },
    'T-Orange-M': { zemin: '#e64f20', vurgu: '#ff5722' },
    'T-Blue-M': { zemin: '#3a3633', vurgu: '#03a9f4' },
    'T-Teal-M': { zemin: '#009688', vurgu: '#4db6ac' },
  };

  /**
   * Listede her tema kendi renk örneğiyle (icon sınıfı: tema-ornek ornek-<n>; renkler SCSS'te).
   * Bir kez üretilir: her değişiklik algılamasında yeni dizi dx-drop-down-button listesini yeniden çizip tıklamayı yutuyordu.
   */
  private _temaListesi?: ThemeObject[];
  get temaListesi(): ThemeObject[] {
    return (this._temaListesi ??= this.themeSettings.map((t, i) => ({ ...t, icon: `tema-ornek ornek-${i}` })));
  }

  ornek(ad: string) {
    return ThemeSwitcherComponent.ORNEKLER[ad] ?? { zemin: '#deedf7', vurgu: '#337ab7' };
  }

  onButtonClick() {
    // this.themeService.switchTheme();
  }
  // Item selection handler for the select box
  onItemClick(e: any) {
    const themeMap: { [key: string]: string } = {
      'Normal': 'light',
      'Gece': 'dark',
      'Kontrast': 'contrast',
      'Carmine': 'carmine',
      'Softdark': 'softblue',
      'Greenmist': 'greenmist',
      'Darkviolet': 'darkviolet',
      'Darkmoon': 'darkmoon',
      'T-Orange-M': 'orange',
      'T-Blue-M': 'blue',
      'T-Teal-M': 'teal'
    };

    // Get the theme based on the selected item name, default to 'light' if not found
    const theme = themeMap[e.itemData.name] || 'light';

    this.themeService.switchTheme(theme);
    this.themeName = e.itemData.name;
  }

}

